// Keeps the browser's HTTP cache out of Supabase reads.
//
// PostgREST answers a GET with no Cache-Control, so the browser may store it.
// When a page comes back through Back/Forward and has to reload, Chrome
// answers the requests it makes before its load event from that cache, even
// when the copy is stale. QA on staging, 2026-10-08: Back to /polls showed the
// list as an earlier load had fetched it, with a deleted poll back as Active
// and a reopened one as Closed, until the coach pressed Refresh. Phones hit it
// every time; fast desktops only some of the time.
//
// Every request this fetch sends asks for `cache: 'no-store'`, unless the
// caller chose a cache mode itself (in `init`, or on a Request it passes).
// Responses are unchanged.
export function createNoStoreFetch(baseFetch) {
  if (typeof baseFetch !== 'function') return baseFetch;

  return function noStoreFetch(input, init) {
    if (init?.cache) return baseFetch(input, init);
    // A Request built with its own cache mode keeps it ('default' is what a
    // Request has when nobody set one).
    if (typeof Request !== 'undefined' && input instanceof Request && input.cache !== 'default') {
      return baseFetch(input, init);
    }
    return baseFetch(input, { ...init, cache: 'no-store' });
  };
}

export default createNoStoreFetch;
